module.exports = __webpack_public_path__ + "img/chrome.75a4bd2d.svg";